import { Box } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "@/pages/eaf/data-entry/components/tables/table-slag/hooks/useSlagTableData";
import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { BorderedTablePaper } from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const SlagTable = () => {
  const {
    state: { slags, heat },
  } = useHeatReportContext();

  const { columns } = useTableData();
  return (
    <BorderedTablePaper elevation={0}>
      <Box p={1}>
        <div
          style={{ height: "199px" }}
          key={`${slags.length}-${heat?.HeatId}`}
        >
          <AgGridReact
            rowData={slags}
            columnDefs={columns}
            defaultColDef={{ ...defaultColDef, sortable: false }}
            {...defaultGridOptions}
          />
        </div>
      </Box>
    </BorderedTablePaper>
  );
};
